export const UPDATE_MESSAGE_POPUP = 'UPDATE_MESSAGE_POPUP';
export const updateMessagePopup = messagePopup=> ({
  type: UPDATE_MESSAGE_POPUP,
  messagePopup: messagePopup
})
